import { FormControl, FormLabel, Stack } from '@mui/material'
import { AnnouncementInput, type AnnouncementInputProps } from './AnnouncementInput'

type FieldStackProps = {
    count: number
    label: string
    name: string
    loading?: boolean
} & AnnouncementInputProps

const LOADING_STACK_COUNT = 4

export const FieldStack = ({ count, label, disabled, name, loading, ...rest }: FieldStackProps) => {
    const stackCount = loading && !count ? LOADING_STACK_COUNT : count
    const range = [...Array(stackCount).keys()]
    return (
        <FormControl disabled={disabled}>
            <FormLabel>{label}</FormLabel>
            <Stack gap={1}>
                {range.map((i) => (
                    <AnnouncementInput
                        name={`${name}.${i}`}
                        key={`${name}.${i}`}
                        disabled={disabled}
                        loading={loading}
                        {...rest}
                    />
                ))}
            </Stack>
        </FormControl>
    )
}

type AuctionAnnouncementsProps = Omit<FieldStackProps, 'count' | 'maxLength'>

export const AOSAnnouncementsField = (props: AuctionAnnouncementsProps) => {
    return <FieldStack maxLength={200} count={1} {...props} />
}

export const ASIAnnouncementsField = (props: AuctionAnnouncementsProps) => {
    return <FieldStack maxLength={78} count={4} {...props} />
}

export type AnnouncementsFieldProps = {
    auctionType?: 'aos' | 'asi' | string | null | undefined
} & AuctionAnnouncementsProps

export const AnnouncementsField = ({ auctionType, loading, ...rest }: AnnouncementsFieldProps) => {
    if (loading && !auctionType) {
        return <FieldStack loading count={4} maxLength={0} {...rest} />
    }

    if (auctionType === 'aos') {
        return <AOSAnnouncementsField loading={loading} {...rest} />
    }
    if (auctionType === 'asi') {
        return <ASIAnnouncementsField loading={loading} {...rest} />
    }

    if (auctionType == null) {
        return <pre>Missing auctionType</pre>
    }

    console.error('Failed to parse Announcements', { auctionType, ...rest })

    return <pre>Failed to parse Announcements</pre>
}
